export const getNumberToWords = (key): string => {
  const keyAsString = String(key);
  const mapping = new Map([
    ['1', 'first'],
    ['2', 'second'],
    ['3', 'third'],
    ['4', 'fourth'],
    ['5', 'fifth'],
    ['6', 'sixth'],
    ['7', 'seventh'],
    ['8', 'eighth'],
  ]);

  return mapping.get(keyAsString) || keyAsString;
};

export const getOrdinal = (num: number): string => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = num % 100;
  return num + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const getFriendlyDate = (
  date: Date,
  locale = 'en-US',
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' },
): string => date.toLocaleDateString(locale, options);

export const formatCentsToCurrency = (cents: number) =>
  (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
